import React, { useContext } from "react";

import SectionCard from "../../../profiles/SectionCard";
import ChecklistCard from "../../../profiles/ChecklistCard";
import ConnectSection, { connectTitle } from "../../../profiles/sections/ConnectSection";
import CompanyProfileCard from "../../reusable/company_profile_card";
import RepresentedByCard from "./represented_by_card";
import SamplesCard from "./samples_card";
import { ProductContext } from "../../data/product_context_management";

// The Checklist card's factor list for a Product profile, in the completion view's factor order —
// the boolean columns id_product_completion_scores_view exposes.
const PRODUCT_CHECKLIST_FACTORS = [
  { key: "has_description", label: "Add a description" },
  { key: "has_category", label: "Add a category" },
  { key: "has_price", label: "Add a price" },
  { key: "has_website", label: "Add a website" },
  { key: "has_supporting_images", label: "Add photos" },
  { key: "has_representation", label: "Get represented by a PR professional" },
];

// The product page's right rail: Checklist, Connect, Company, Represented by, Samples (Alyssa's
// order, Checklist first as on Expert.jsx). Each card's occupancy is decided in the provider so the
// page can collapse the rail column without the two disagreeing. Message lives in the header.
function ProductSidebar() {
  const {
    product,
    checklistScore,
    checklistIsLoading,
    checklistHidden,
    hideChecklist,
    contactDetails,
    showConnectCard,
    showCompanyCard,
    showRepresentedByCard,
    showSamplesCard,
    setOpenEditModal,
  } = useContext(ProductContext);

  // Deep-links checklist rows to the edit modal section that actually fixes them. `has_category` and
  // `has_website` stay static: neither has an edit modal today.
  const checklistFactorActions = {
    has_description: () => setOpenEditModal("DESCRIPTION"),
    has_price: () => setOpenEditModal("HEADER"),
  };

  return (
    <div className="h-100">
      {!checklistHidden && (
        <ChecklistCard
          score={checklistScore}
          factors={PRODUCT_CHECKLIST_FACTORS}
          isLoading={checklistIsLoading}
          factorActions={checklistFactorActions}
          onHide={hideChecklist}
        />
      )}

      {showConnectCard && (
        <ConnectSection id="product-rail-connect" title={connectTitle(product?.name)} contactDetails={contactDetails} />
      )}

      {showCompanyCard && (
        <SectionCard id="product-rail-company" title="Company">
          <CompanyProfileCard
            name={product.company_name}
            slug={product.company_slug}
            migrateId={product.company_migrate_id}
            imageUrl={product.company_profile_image_url}
          />
        </SectionCard>
      )}

      {showRepresentedByCard && <RepresentedByCard />}

      {showSamplesCard && <SamplesCard />}
    </div>
  );
}

export default ProductSidebar;
